import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Refresh } from '../../icons';
import { bootstrapApp } from '../../actions/api';
import './style.css';

class Maintenance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refreshing: false
    };
  }
  componentDidMount() {
    this._ismounted = true;
    this.interval = setInterval(() => {
      this.handleRefresh();
    }, 30 * 1000);
  }

  componentWillUnmount() {
    this._ismounted = false;
    clearInterval(this.interval);
  }
  handleRefresh = () => {
    this.setState({refreshing: true});
    this.props.bootstrapAttempt().then(() => {
      if (this._ismounted) {
        this.setState({refreshing: false});
      }
    });
  }
  render() {
    const spinning = this.state.refreshing ? 'spinning' : '';
    return (
      <div className="maintenance-wrapper">
        <div className="maintenance-message">
          Server is under maintenance.
          {/*<a className="refresh-btn" href={uri.rootPageUri}>*/}
            <Refresh
              color="#8bc027"
              height={"50px"}
              width={"50px"}
              className={`refresh-icon ${spinning}`}
              onClick={this.handleRefresh}/>
          {/*</a>*/}
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    bootstrapAttempt: () => dispatch(bootstrapApp()),
  };
};
export default connect(null, mapDispatchToProps)(Maintenance);


// WEBPACK FOOTER //
// ./src/components/Maintenance/Maintenance.jsx